
    <div class="message-error">
        <img src="assets/proof-life/error.svg" alt="Ilustração (Erro)"/>
        <p class="message-error__title">Poxa, algo deu errado!</p>
    </div>
    <div class="message-error__line-break"></div>

    <div class="message-error">
        <p class="message-error__message">{{ messageError }}</p>
        <button class="button button--primary button--medium" (click)="handleOnConfirm()" type="button">{{ textConfirm }}</button>
    </div>

